import React from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../ExpensesWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { validateAverageSpentPerMonth } from '../ExpensesWorkflowValidators';
import InputDollar from '../../InputDollar/InputDollarView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import averageSpentPerMonthShouldSkip from './AverageSpentPerMonthShouldSkip';

const AverageSpentPerMonthView = ({
  branch,
  workflowId,
  clientId,
  hasFamily,
  averageSpent,
  averageSpentChanged,
  totalExpenses,
  store,
  isGoingForward,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    id="AverageSpentPerMonth"
    canSkip={averageSpentPerMonthShouldSkip(isGoingForward, averageSpent)}
  >
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.AverageSpentPerMonth`} />

    <h2>
      How much money, on average, {hasFamily ? 'does your family' : 'do you'} spend each month?
    </h2>
    <h3>Exclude mortgage and other loan payments.</h3>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            maxLength="256"
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Monthly Amount"
            className="md"
            value={averageSpent}
            id="adv-monthly-amount"
            onChange={averageSpentChanged(totalExpenses, clientId, store(workflowId))}
          />
        </li>
      </ul>
    </AdvForm>
    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validateAverageSpentPerMonth(averageSpent)}
      validationId={`${BACKEND_KEY}.AverageSpentPerMonth`}
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'spend_completed')}
    />
  </AdvWorkflowStep>
);

AverageSpentPerMonthView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  hasFamily: PropTypes.bool.isRequired,
  averageSpent: createCustomPropType(isNumeric).isRequired,
  averageSpentChanged: PropTypes.func.isRequired,
  totalExpenses: PropTypes.shape({
    Amount: createCustomPropType(isNumeric).isRequired,
  }).isRequired,
  store: PropTypes.func.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
};

export default AverageSpentPerMonthView;
